import { render, staticRenderFns } from "./averageWage.vue?vue&type=template&id=7181515a&scoped=true&"
import script from "./averageWage.vue?vue&type=script&lang=js&"
export * from "./averageWage.vue?vue&type=script&lang=js&"
import style0 from "./averageWage.vue?vue&type=style&index=0&id=7181515a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181515a",
  null
  
)

export default component.exports